import { queryKey as useRecommendationFeedbacksQueryKey } from "@/composables/recommendationFeedbacks/useRecommendationFeedbacks";
import { queryKey as recommendationFeedbackBooleanQueryKey } from "@/composables/recommendationFeedbackBooleans/useRecommendationFeedbackBoolean";

export const onSettled = ({
  queryClient,
}) => (data) => {
  queryClient.invalidateQueries({ queryKey: useRecommendationFeedbacksQueryKey({ projectId: data.data.feedback.projectId }) });
  queryClient.invalidateQueries({ queryKey: recommendationFeedbackBooleanQueryKey({ projectId: data.data.feedback.projectId, tokenType: data.data.feedback.tokenType }) });
}
